import { API2_HOST } from '../../helpers/urlHelper';
import { basePost, basePatch } from 'services/base-services/baseService'
import axios from 'axios';
import { ApiResponse } from 'helpers/stockLocationHelpers';

axios.defaults.withCredentials = true;
const baseURL = `${API2_HOST}/bs-sectors`;
const getSectors = async (id) => {
    const result = new ApiResponse();
    const res = await axios({
        method: 'get',
        url: `${baseURL}?kpiBoardId=${id}`,
    })
        .catch((error) => {
            console.log('AXIOS ERROR', error)
            return result;
        });

    if (res.status !== 200)
        return result;

    result.success = res.data.success;
    result.data = res.data?.data
    result.message = res.data?.message;
    return result;
}

const post = async (request) => {
    return await basePost(baseURL, request);
}

const patch = async (id, request) => {
    return await basePatch(baseURL, request, id);
}

export {
    getSectors,
    post,
    patch
};
